

export const socialMedia = {
    instagram: "https://www.instagram.com/sascidu/",
    twitter: "https://twitter.com/CIDU_SAS",
    facebook: "https://www.facebook.com/SASCIDU",
    linkedin: "https://www.linkedin.com/in/jonathan-ortiz-casta%C3%B1o-5938521b5/",
    homepage: "https://cidu.com.co", 

  };